import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { OtaApiService } from '../CommonController/ota-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-ota-master',
  templateUrl: './ota-master.component.html',
  styleUrls: ['./ota-master.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    MatTooltip,
  ],
})
export class OtaMasterComponent implements OnInit {
  pageSize = 10;
  totalItems = 0;
  currentPage = 1;
  searchString = '';
  otaItems = [];

  otaMaster: FormGroup;
  searchForm: FormGroup;

  AddOtaItemBtn = true;
  UpdateOtaItem = false;
  isAddOtaCommand = false;

  InputFields = ['YES', 'NO'];
  otaTypeList = ['GET', 'SET', 'CLR'];

  loggedInUserId = '';
  updatedData;
  viewOtaMaster = false;
  createOtaMaster = false;
  updateOtaMaster = false;
  deleteOtaMaster = false;
  userPermissions = [];

  constructor(
    public formBuilder: FormBuilder,
    public commonApiService: CommonApiService,
    public otaApiService: OtaApiService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.isAddOtaCommand = false;
    this.setOtaMasterForm();
    this.fetchOtaMaster();
  }

  checkPermission() {
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId') || '';
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Ota' && element.view === true) {
        this.viewOtaMaster = true;
      }
      if (element.pageName === 'Ota' && element.create === true) {
        this.createOtaMaster = true;
      }
      if (element.pageName === 'Ota' && element.update === true) {
        this.updateOtaMaster = true;
      }
      if (element.pageName === 'Ota' && element.delete === true) {
        this.deleteOtaMaster = true;
      }
    });
  }

  setOtaMasterForm() {
    this.otaMaster = this.formBuilder.group({
      otaCommandExample: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      name: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      otaCommandType: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      isInputFieldRequired: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      otaCommand: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });

    this.searchForm = this.formBuilder.group({
      searchInput: new FormControl(''),
    });
  }

  fetchOtaMaster() {
    this.spinner.show();
    this.otaApiService
      .getOtaCommandList(
        this.currentPage - 1,
        this.pageSize,
        '',
        this.searchString
      )
      .subscribe({
        next: (res) => {
          this.otaItems = res.data;
          this.totalItems = res.totalItems;
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        },
        error: (err) => {
          this.commonApiService.openSnackbar(err.error.message);
          this.otaItems = [];
          this.spinner.hide();
        },
      });
  }

  onSearch(event) {
    this.searchForm?.get('searchInput')?.setValue(event);
    this.searchString = event;
    this.currentPage = 1;
    this.fetchOtaMaster();
  }

  submitOTACommand() {
    const payload = this.otaMaster.value;
    if (this.otaMaster.invalid) {
      SharedValidators.markAllAsTouched(this.otaMaster);
      return;
    }

    if (this.otaMaster?.get('isInputFieldRequired')?.value === 'YES') {
      if (!this.otaMaster?.get('otaCommand')?.value.includes('VAL')) {
        this.commonApiService.openSnackbar("Command does NOT contain 'VAL'");
        return;
      }
    }

    payload.userId = this.loggedInUserId;
    payload.id = 0;
    if (this.UpdateOtaItem) {
      payload.id = this.updatedData.id;
    }

    this.spinner.show();
    this.otaApiService.saveOtaMaster(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.isAddOtaCommand = false;
        }
      },
      error: (err) => {
        this.spinner.hide();
        if (err.error?.message === 'Validation Error' && err.error.errors) {
          const errorMessages = Object.values(err.error.errors);
          errorMessages.forEach((error) => {
            this.commonApiService.openSnackbar(error);
          });
        } else {
          this.commonApiService.openSnackbar(
            err.error?.message || 'Something went wrong!'
          );
        }
      },
      complete: () => {
        this.spinner.hide();
        this.fetchOtaMaster();
      },
    });
  }

  updateData(data) {
    this.AddOtaItemBtn = false;
    this.UpdateOtaItem = true;
    this.updatedData = data;
    this.otaMaster.controls['otaCommandExample'].setValue(
      data.otaCommandExample
    );
    this.otaMaster.controls['name'].setValue(data.name);
    this.otaMaster.controls['isInputFieldRequired'].setValue(
      data.inputRequired
    );
    this.otaMaster.controls['otaCommand'].setValue(data.otaCommand);
    this.otaMaster.controls['otaCommandType'].setValue(data.type);
    this.isAddOtaCommand = true;
  }

  delete(id) {
    if (confirm('Do you want to delete this OTA Command?')) {
      this.otaApiService.deleteOTACommand(id).subscribe((res) => {
        this.commonApiService.openSnackbar(res.message);
        this.ngOnInit();
      });
    }
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchOtaMaster();
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize;
    this.currentPage = 1;
    this.fetchOtaMaster();
  }

  navigateBack() {
    if (this.isAddOtaCommand) {
      this.isAddOtaCommand = false;
      this.fetchOtaMaster();
    } else {
      this.commonApiService.back();
    }
  }

  onRefresh() {
    if (this.isAddOtaCommand) {
      this.spinner.show();
      if (this.UpdateOtaItem) {
        this.updateData(this.updatedData);
      } else {
        this.otaMaster.reset();
      }
      this.spinner.hide();
    } else {
      this.ngOnInit();
    }
  }

  addOtaCommand() {
    this.AddOtaItemBtn = true;
    this.UpdateOtaItem = false;
    this.isAddOtaCommand = true;
    this.otaMaster.reset();
  }
}
